import React , { useState, useEffect, useRef } from "react";
import './MessageFromBotCard.css';

import { MdSend } from 'react-icons/md';
import { MdThumbUp } from 'react-icons/md';
import { MdThumbDown } from 'react-icons/md';
import { BiCheckDouble } from 'react-icons/bi';


const MessageFromBotCard = (props) => {
        
    const [isOptionShown, setIsOptionShown] = useState(true);
    const [loading, setLoading] = useState(true);

    const userTyped = useRef(null);
    const botResponse = useRef(null)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
            if(props.isVoice){
                let utterence = new SpeechSynthesisUtterance(props.utterance);
                // let voice = speechSynthesis.getVoices();
                // utterence.voice = voice[1]
                window.speechSynthesis.speak(utterence)
            }
            // console.log("from-bot: render msg is called")
        }, 1000);
        return () => {
            // cleanup
            setIsOptionShown(false)
        };
    }, [props]);

    useEffect(() => {
        botResponse.current.scrollIntoView();
    }, [loading]);

    return(
        <div ref={botResponse} className="bot-chatbox-main-bot">
            {
                loading ? 
                <span className="bot-chatbox-main-bot-loading">
                    <div className="loader"></div>
                </span>
                :
                props.msg.map( (element,index) =>{
                    return(
                        <span key={index} className="bot-chatbox-main-bot-msg" >
                            <p dangerouslySetInnerHTML={{__html: element}}></p>
                            <div className="bot-chatbox-msg-status">
                                <span className="bot-bot-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                <span style={{"fontSize":"18px"}}><BiCheckDouble/></span>
                            </div>
                        </span>
                    )
                })
            }
            {   
                loading ? 
                null
                :
                props.type === "button" && isOptionShown ? 
                props.option.map( (element,index)=>{
                    if(element.isLink){
                        return <React.Fragment key={index}> <div className="bot-options-link" dangerouslySetInnerHTML={{__html: element.btn}}></div> </React.Fragment>
                    }
                    else{
                        return <div className="bot-options" key={index} onClick={ ()=>{ props.selectOption(element.keyword);setIsOptionShown(false) } } > {element.btn} </div>
                    }
                })
                :
                props.type === "input"  && isOptionShown ?
                <div className="get-user-response-cont">
                    <input className="get-user-response" autoFocus onKeyDown={ (e)=>{ if(e.key === "Enter"){ document.getElementById("send").click(); } } } ref={userTyped} type={"text"} placeholder="Type your response here."/>
                    <button id="send" onClick={ ()=> {setIsOptionShown(false);props.selectOption(userTyped.current.value,"dob")} }><MdSend/></button>
                </div>
                :
                null
            }
            {
                props.prompt.type === "contact_update" && isOptionShown ?
                <>
                    <span class="bot-chatbox-main-bot-msg">
                        <p>Hi <b>{props.prompt.name}</b>, we have noticed that some of your contact details are not updated with us. To receive regular alerts about your ICICI Pru Life policy, kindly update the below detail(s):
                        <br/><b>{props.prompt.option[0]}</b><br/>Here are 4 quick ways to update these detail(s). Select your preferred channel to know more.<br/>
                        </p>
                        <div className="bot-bot-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                    </span>
                    <div className="bot-options" onClick={ ()=>{ props.selectOption("mobile app","msg");setIsOptionShown(false) } }>Mobile App</div>
                    <div className="bot-options" onClick={ ()=>{ props.selectOption("webiste","msg");setIsOptionShown(false) } }>Webiste</div>
                    <div className="bot-options" onClick={ ()=>{ props.selectOption("call center","msg");setIsOptionShown(false) } }>Call Center</div>
                    <div className="bot-options" onClick={ ()=>{ props.selectOption("icici pru life branch","msg");setIsOptionShown(false) } }>ICICI Pru Life Branch</div>
                </>
                :
                props.prompt.type === "intuitive" && isOptionShown ?
                <>
                    <span className="bot-chatbox-main-bot-msg" >
                        <p>Hi <b>{props.prompt.name}</b>, premium of your policy/ies is due for payment. Simply click onthe policy you want to renew and we can assist you with the payment:</p>
                        <div className="bot-bot-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                    </span>
                    {
                        props.prompt.option.map( (element,index)=>{
                        if(element.isLink){
                            return <React.Fragment key={index}> <div className="bot-options-link" dangerouslySetInnerHTML={{__html: element.btn}}></div> </React.Fragment>
                        }
                        else{
                            return <div className="bot-options" key={index} onClick={ ()=>{ props.selectOption(element.keyword);setIsOptionShown(false) } } > {element.btn} </div>
                        }
                        })
                    }
                </>
                :
                props.prompt.type === "feedback" && isOptionShown ?
                <>
                    <span className="bot-chatbox-main-bot-msg" >
                        <p>Was it helpful?</p>
                        <div className="bot-bot-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                    </span>
                    <div className="bot-feedback">
                        <div className="bot-feedback-btn" onClick={ ()=>{ props.selectOption("Yes","msg");setIsOptionShown(false) } }><MdThumbUp/></div>
                        <div className="bot-feedback-btn" onClick={ ()=>{ props.selectOption("No","msg");setIsOptionShown(false) } }><MdThumbDown/></div>
                    </div>
                </>
                :
                null
            }
        </div>
    )
}

export default MessageFromBotCard;
